module.exports = __webpack_public_path__ + "static/img/2.609458c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/bg/2.jpg
// module id = dJ3u
// module chunks = 0